"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Label_module_css_1 = __importDefault(require("./Label.module.css"));
var Label = (function (_super) {
    __extends(Label, _super);
    function Label() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Label.prototype.render = function () {
        var _a = this.props, children = _a.children, text = _a.text, error = _a.error, required = _a.required, _b = _a.className, className = _b === void 0 ? "" : _b, backendErrors = _a.backendErrors;
        return (react_1.default.createElement("label", { className: Label_module_css_1.default.root + " " + className },
            text && (react_1.default.createElement("p", { className: Label_module_css_1.default.text },
                text,
                required && react_1.default.createElement("span", { className: Label_module_css_1.default.required }, " *"))),
            children,
            error && (react_1.default.createElement("div", { className: Label_module_css_1.default.errorWrapper },
                react_1.default.createElement("p", { className: Label_module_css_1.default.errorText }, error))),
            backendErrors && (react_1.default.createElement("div", { className: Label_module_css_1.default.errorWrapper },
                react_1.default.createElement("p", { className: Label_module_css_1.default.errorText }, backendErrors)))));
    };
    return Label;
}(react_1.Component));
exports.Label = Label;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTGFiZWwuanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9jb21wb25lbnRzL0NhcHRjaGEvTGFiZWwvTGFiZWwudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSw2Q0FBc0M7QUFDdEMsd0VBQXVDO0FBV3ZDO0lBQTJCLHlCQUFvQjtJQUEvQzs7SUF5QkEsQ0FBQztJQXhCVSxzQkFBTSxHQUFiO1FBQ1UsSUFBQSxlQUE2RSxFQUE1RSxzQkFBUSxFQUFFLGNBQUksRUFBRSxnQkFBSyxFQUFFLHNCQUFRLEVBQUUsaUJBQWMsRUFBZCxtQ0FBYyxFQUFFLGdDQUEyQixDQUFBO1FBQ25GLE9BQU8sQ0FDSCx5Q0FBTyxTQUFTLEVBQUssMEJBQU0sQ0FBQyxJQUFJLFNBQUksU0FBVztZQUMxQyxJQUFJLElBQUksQ0FDTCxxQ0FBRyxTQUFTLEVBQUUsMEJBQU0sQ0FBQyxJQUFJO2dCQUNwQixJQUFJO2dCQUNKLFFBQVEsSUFBSSx3Q0FBTSxTQUFTLEVBQUUsMEJBQU0sQ0FBQyxRQUFRLFNBQVcsQ0FDeEQsQ0FDUDtZQUNBLFFBQVE7WUFDUixLQUFLLElBQUksQ0FDTix1Q0FBSyxTQUFTLEVBQUUsMEJBQU0sQ0FBQyxZQUFZO2dCQUMvQixxQ0FBRyxTQUFTLEVBQUUsMEJBQU0sQ0FBQyxTQUFTLElBQUcsS0FBSyxDQUFLLENBQ3pDLENBQ1Q7WUFDQSxhQUFhLElBQUksQ0FDZCx1Q0FBSyxTQUFTLEVBQUUsMEJBQU0sQ0FBQyxZQUFZO2dCQUMvQixxQ0FBRyxTQUFTLEVBQUUsMEJBQU0sQ0FBQyxTQUFTLElBQUcsYUFBYSxDQUFLLENBQ2pELENBQ1QsQ0FDRyxDQUNYLENBQUE7SUFDTCxDQUFDO0lBQ0wsWUFBQztBQUFELENBQUMsQUF6QkQsQ0FBMkIsaUJBQVMsR0F5Qm5DO0FBekJZLHNCQUFLIn0=